"use client";
import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ShoppingCart, ShoppingBag } from "lucide-react";
import MobileVarientSelection from "./MobileVarientSelection";
import { selectAllCarts } from "../../features/cartPage/cartPageSlice";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";

export default function AddToCartButton({
    selectProduct,
    qtys,
}) {
    const router = useNavigate();
    const cart = useSelector(selectAllCarts);
    const selectedVariant = useSelector(
        (state) => state.productDetail.selectedVariant
    );
    const [isBottomSheetOpen, setBottomSheetOpen] = useState(null);

    const handleOpenSheet = (name) => setBottomSheetOpen(name);
    const handleCloseSheet = () => setBottomSheetOpen(null);

    const isInCart = () =>
        Array.isArray(cart) &&
        cart?.some((i) => i?.skuDetails?.SKU_ID === selectedVariant?.SKU_ID);


    return (
        <>
            {/* ✅ Sticky Bottom Buttons */}
            <div className="fixed bottom-0 left-0 right-0 px-4 z-40 flex justify-center bg-white-1 p-4 shadow-[0_8px_20px_rgba(0,0,0,0.40)] ">
                <div className="flex w-[400px] max-w-full gap-3">
                    {/* Add to Cart */}
                    <motion.button
                        whileTap={{ scale: 0.96 }}
                        whileHover={{ scale: 1.02 }}
                        onClick={() => handleOpenSheet("add")}
                        className="flex-1 h-[50px] flex items-center justify-center gap-2 rounded-[5px] bg-green text-white-1 font-semibold text-[15px] shadow-[0_8px_20px_rgba(0,0,0,0.12)] transition-all duration-200"
                    >
                        <ShoppingCart size={22} />
                        {isInCart() ? "Added" : "Add to Cart"}
                    </motion.button>

                    {/* Buy Now */}
                    <motion.button
                        whileTap={{ scale: 0.96 }}
                        whileHover={{ scale: 1.02 }}
                        onClick={() => { isInCart() ? router("/carts") : handleOpenSheet("buy")}}
                        className="flex-1 h-[50px] flex items-center justify-center gap-2 rounded-[5px] bg-blue text-white-1 font-semibold text-[15px] shadow-[0_8px_20px_rgba(0,0,0,0.15)] transition-all duration-200"
                    >
                        {isInCart() ? <ShoppingCart size={20} /> : <ShoppingBag size={22} />}
                        {isInCart() ? "Checkout" : "Buy Now"}
                    </motion.button>
                </div>
            </div>

            {/* ✅ Bottom Sheet */}
            <AnimatePresence>
                {isBottomSheetOpen && (
                    <>
                        {/* Backdrop */}
                        <motion.div
                            className="fixed inset-0 bg-black-1/40 backdrop-blur-[3px] z-40"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0, height: 0 }}
                            onClick={handleCloseSheet}
                        />

                        {/* Sheet Content */}
                        <motion.div
                            initial={{ y: "100%" }}
                            animate={{ y: 0 }}
                            exit={{ y: "100%" }}
                            transition={{ type: "spring", stiffness: 120, damping: 18 }}
                            className="fixed bottom-0 left-0 right-0 bg-white-1 text-black-1 rounded-t-3xl shadow-2xl z-50 max-h-[80vh] overflow-y-auto"
                        >

                            {/* Embedded Variant Selector */}
                            <MobileVarientSelection
                                selectProduct={selectProduct}
                                qtys={qtys}
                                handleCloseSheet={handleCloseSheet}
                                isBottomSheetOpen={isBottomSheetOpen}
                            />
                        </motion.div>
                    </>
                )}
            </AnimatePresence>
        </>
    );
}
